export default "__VITE_ASSET__DbA92py2__"